import { FiSidebar } from 'react-icons/fi';
import PropTypes from 'prop-types';
import { HiRefresh } from 'react-icons/hi';
import useChatbotStore from '@stores/chatbotStore';

export const ChatHeader = ({ toggleChatbotHandler }) => {
    const { clearChatMessages } = useChatbotStore();
    return (
        <div className="h-14 box-border border-b-2 border-slate-100 flex items-center justify-between mx-4">
            <div className="chat-sidebar-trigger text-2xl cursor-pointer text-gray-600 hover:text-gray-800">
                <FiSidebar onClick={() => toggleChatbotHandler()} />
            </div>
            <div className="chat-header-actions flex items-center gap-2">
                <HiRefresh
                    className="text-gray-400 cursor-pointer hover:text-gray-800 text-2xl"
                    onClick={() => clearChatMessages()}
                />
            </div>
        </div>
    );
};

ChatHeader.propTypes = {
    toggleChatbotHandler: PropTypes.func.isRequired,
};
